export const styles = {
  root: {
    backgroundColor: '#FAFAFA',
    textWrap: 'nowrap',
  },
  popover: {
    '& .MuiPaper-root': {
      marginTop: '17px',
      boxShadow: '0 5px 5px 7px rgba(0,0,0,0.05)',
      //maxWidth: '320px',
    },
  },
}
